import { Inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";

import { SessionHandlerService } from "./session-handler.service";
import { selectSessionState, SessionState } from "../model/session.state.model";
import { SessionCommonActionFactory, SessionCommonActionFactoryToken } from "../action/session.common.action.factory";
import { Store } from "@ngrx/store";
import { LocalStoreService } from "../../../../core/utils/local-store.service";
import { MatDialog } from "@angular/material/dialog";
import { SessionTimeoutInfoComponent } from "@feature_core/session/component/session-timeout-info.component";


@Injectable()
export class SessionHandlerServiceImpl implements SessionHandlerService {

    protected _router: Router;
    protected _sessionActionFactory: SessionCommonActionFactory;
    protected _isInitialized = false;
    protected _ngrxStore: Store<any>;

    constructor(
        protected dialog: MatDialog,
        ngrxStore: Store<any>,
        router: Router,
        @Inject(SessionCommonActionFactoryToken)
        sessionActionFactory: SessionCommonActionFactory,
    ) {
        this._router = router;
        this._sessionActionFactory = sessionActionFactory;
        this._ngrxStore = ngrxStore;
    }

    /**
     * This method makes the session handler service listen to the session state and handle its changes.
     */
    init(): void {
        if (!this._isInitialized) {
            this._isInitialized = true;
            this._ngrxStore.select(selectSessionState).subscribe(this.handleSession.bind(this));
        }
    }

    /**
     * This method starts the logout process. It calls the backend with a logout request and then it should also handle
     * the resetting of the redux state.
     */
    logout(reason?: any): void {
        this._sessionActionFactory.logout().subscribe(
          this.endSession.bind(this, reason),
          this.endSession.bind(this, reason)
        );
    }

    /**
     * This method calls the backend to keep the session alive.
     */
    reviveSession(): void {
        this._sessionActionFactory.reviveSession().subscribe();
    }

    clearSession(): void {
      this._sessionActionFactory.logout().subscribe();
    }

    protected handleSession(sessionState: SessionState): void {
        if (sessionState.remainingTime === 0) {
            // this.logout(null);
            const dialogRef = this.dialog.open(SessionTimeoutInfoComponent, {
              disableClose: false,
              width: "600px",
              autoFocus: false,
              panelClass: "mkb-card3dsecure-modal"
            });

            dialogRef.afterClosed().subscribe(resp => {
              this.logout(null);
            }, err => {
              this.logout(null);
            });
            return;
        }

        if (sessionState.fatalError) {
            this.logout(null);
            return;
        }

        if (sessionState.reviveNeededIn === 0) {
            this.reviveSession();
        }
    }

    protected endSession(reason?: any): void {
        LocalStoreService.clear();
        LocalStoreService.clearSessionTime();
        this._router.navigate(["mkb3ds", "login"]);
    }
}
